import type {PlayerEvent, PlayerResizedEvent} from 'bitmovin-player';
import {useEffect} from 'react';
import {usePlayerContext} from './usePlayerContext';

export const usePlayerResize = (
  callback: (e: PlayerResizedEvent) => void
): void => {
  const {player} = usePlayerContext();

  useEffect(() => {
    if (!player) return;

    player.on('playerresized' as PlayerEvent.PlayerResized, callback);
  }, [player, callback]);
};
